export default class ApacuanaSuccess {
  constructor(data, statusCode = 200) {
    this.success = true;
    this.statusCode = statusCode;
    this.name = "ApacuanaSuccess";
    this.data = data;
  }
}